interface TestimonialsType {
    name: string;
    avatar: string;
    star: number;
    review: string;
}

const testimonials: TestimonialsType[] = [
    {
        name: "Vani Goal",
        avatar: "/avatars/vani-goal.png",  
        star: 5,
        review: "Dr. Hirak Pahari Sir... The name is enough for me and for my family that we blindly trust him... Sir is not just a another surgeon .. Sir is a miraculous man and very supportive human being..... He helped me through very tough time.... 24/7 Sir is available on call when my elder brother was hospitalized.... Sir is very polite, generous & kindest human being... Even if u not from Delhi/NCR... Or suffering from any type of hepatology problem atleast once u take opinion from him.... He is the Best surgeon of our Country.... He never give false hope or advice.... Sir is one in a Billion... Thank you for Everything Sir...."
    },
    {
        name: "Advocate Singh",
        avatar: "/avatars/advocate-singh.png",  
        star: 5,
        review: "Hirak means Diamond -The Diamond of Sir Ganga Ram Hospital My mother suffered from Metasatatic Adenocarcinoma in may 2024. There are many Doctors but Hirak Sir is only One. Every Best Hospital of Delhi/NCR rejects her on the ground of survival chances is 1%. She was admitted there all her treatments till today was done under Hirak Sir. I lost all my hope but it was Hirak Sir who gave my mother a new life. Without any second thought He is a great Surgeon of our Country. I'm always grateful to him for everything he done for me. Even words are not enough to describe his perfection, potentiality, professionalism, gesture, kindness & humbleness, Hirak Sir is a Shadow of God."
    },
    {
        name: "Ravinath Shendre",
        avatar: "/avatars/ravinath-shendre.png",  
        star: 5,
        review: "My name is ravinath shendre. Dr. Hirak sir done my liver transplant last year. He is the best. You can trust him with your life. He will do everything possible and impossible to help you out. An outstanding doctor and a superb human being."
    },
    {
        name: "Harshada Gharat",
        avatar: "/avatars/harshada-gharat.png",
        star: 5,
        review: "Dr Pahari treated one of my relative. There were no unresolved questions, no doubts, and no ambiguity. He is clearly concerned about his patients. He provided excellent treatment to my jiju."
    },
    {
        name: "Snehal Teli",
        avatar: "/avatars/snehal-teli.png",
        star : 5, 
        review: "Dr Hirak pahari is an highly experienced and brilliant doctor he is not proud of his intelligence at all full of humanity can be said to be angels on earth my liver transplant operated on 13 th feb 28 Feb was a like rebirth i am very thankful to Hirak sir and entire team",
    },
    {
        name: "Shayane Basak",
        avatar: "/avatars/shayane-basak.png",
        star: 5, 
        review: "In 2021 I had my operation done by Dr. Hirak Pahari. I was suffering from stomach pain for many months. I am very well after the operation. He is like God to me."
    },
    {
        name: "Ashish Sourabh",
        avatar: "/avatars/ashish-sourabh.png",
        star: 5, 
        review: "The best doctor I have ever encountered !! My mom had a very bad phase due to cancer and followed by intestinal blockage. Dr Pahari, operated her and even made stoma reversal successfully. A very amazing human being and has no tantrums like other senior doctor, he understands every person’s situation and explain everything in simple language. Even supports to the utmost level, so that person can bear such expensive treatment. I am so glad that Dr Pahari took the case and gave back a normal life to my mom. I will be always grateful 🙏🏼 Thank you so much sir, god bless you with all happiness and prosperity 😇"
    }
];

export default testimonials;